import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {OccEndpointsService, TranslationService} from "@spartacus/core";
import {catchError, map, Observable} from "rxjs";
import {failStatus, successStatus} from "../../../../core/models/request-status.model";
import {PriceMediaRequestConfig, PriceMediaStatusRequest} from "./price-media.model";

@Injectable({
  providedIn: 'root',
})
export class PriceMediaAdapter {
  constructor(
    private http: HttpClient,
    private translationService: TranslationService,
    private occEndPointService: OccEndpointsService,
  ) {
  }

  loadPriceMedia(priceMedia: any): Observable<any> {
    const url = this.occEndPointService.buildUrl('loadPriceMedia');

    return this.http.post(url, priceMedia).pipe(
      map(response => {
        return {
          ...{
            priceMedia: response,
            ...successStatus,
          },
        };
      }),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            ...failStatus,
            message: textError,
          })),
        );
      }),
    );
  }

  getPriceMedias(priceMediaRequestConfig: PriceMediaRequestConfig): Observable<PriceMediaStatusRequest> {
    const url = this.occEndPointService.buildUrl('getPriceMedias', {
      queryParams: {
        fromDate: priceMediaRequestConfig.fromDate,
        toDate: priceMediaRequestConfig.toDate,
      },
    });

    return this.http.get(url).pipe(
      map((response: any) => ({
        priceMedias: response,
        ...successStatus,
      })),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            ...failStatus,
            message: textError,
          })),
        );
      }),
    );
  }

}
